import { AppBar, Theme, useMediaQuery } from '@mui/material';
import { MenuWithChildren } from '../../types/menu';
import { Breadcrumb } from '../breadcrumb/Breadcrumb';
import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';

export interface HeaderProps {
  isLoading?: boolean;
  menus: MenuWithChildren[];
}
export const Header: React.FC<HeaderProps> = ({ isLoading = false, menus }) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <AppBar position="sticky" sx={{ bgcolor: 'common.white', boxShadow: 10, borderBottom: 1, borderColor: 'grey.100' }}>
      {isDesktop ? (
        <DesktopHeader menus={menus} isLoading={isLoading} />
      ) : (
        <MobileHeader menus={menus} isLoading={isLoading} />
      )}
      <Breadcrumb />
    </AppBar>
  );
};
